import { SET_PARAMS } from './constants';

const setParamsToRedux = params => ({
  type: SET_PARAMS,
  payload: params,
});

export const setParams = params => {
  return dispatch => {
    dispatch(setParamsToRedux(params));
  };
};



// WEBPACK FOOTER //
// ./src/containers/ReservationConnectionForm/actions.js